import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const SeriesFields = ({ form, set, inputCls }) => {
  const [existing, setExisting] = useState([]);
  useEffect(() => { api.get("/series").then((r) => setExisting(r.data)).catch(() => {}); }, []);

  return (
    <div className="grid gap-3" data-testid="admin-series-fields">
      <div>
        <label htmlFor="series" className="block meta !text-[var(--ink-2)] mb-2">Series (optional)</label>
        <input id="series" list="series-options" value={form.series || ""} onChange={set("series")} placeholder="e.g. Life on the road" className={inputCls} data-testid="admin-series-input" />
        <datalist id="series-options">{existing.map((s) => <option key={s} value={s} />)}</datalist>
      </div>
      {form.series && (
        <div>
          <label htmlFor="part" className="block meta !text-[var(--ink-2)] mb-2">Part number</label>
          <input id="part" type="number" min={1} max={999} value={form.series_part ?? ""}
            onChange={(e) => set("series_part")(e.target.value ? Number(e.target.value) : null)}
            className={`${inputCls} w-24`} data-testid="admin-series-part-input" />
        </div>
      )}
    </div>
  );
};
